import { render } from "./ScientificInformationCard.vue?vue&type=template&id=7d093e18&scoped=true"
import script from "./ScientificInformationCard.vue?vue&type=script&lang=js"
export * from "./ScientificInformationCard.vue?vue&type=script&lang=js"

import "./ScientificInformationCard.vue?vue&type=style&index=0&id=7d093e18&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d093e18"]])

export default __exports__